export function resetModalsPositions() {
  document.querySelectorAll<HTMLElement>('.window__modal').forEach((c) => {
    c.style.zIndex = '1200';
  });
}

export function bringToTop(modalElement: HTMLElement) {
  document.querySelectorAll<HTMLElement>('.window__modal').forEach((c) => {
    if (c.querySelector<HTMLElement>('.modal__main') === modalElement) {
      c.style.zIndex = '1201';
    } else {
      c.style.zIndex = '1200';
    }
  });
}
